<template>
  <div style="background: #FEFBFB;">
    <nav
      class="
        navbar navbar-transparent navbar-color-on-scroll
        fixed-top
        navbar-expand-lg
      "
      color-on-scroll="100"
      id="sectionsNav"
    >
      <div class="container-fluid">
        <div class="navbar-translate">
          <router-link to="/">
            <img
              src="../../public/assets/img/logo.png"
              class="img-fluid ml-sm-4 cursor-pointer"
              style="width: 70px"
              alt
            />
            <!-- <span class="text-orange text-center">
              <b>Employability Portal</b></span
            > -->
          </router-link>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="navbar-toggler-icon" />
            <span class="navbar-toggler-icon" />
            <span class="navbar-toggler-icon" />
          </button>
        </div>

        <div class="collapse navbar-collapse">
          <ul class="navbar-nav pt-2 ml-auto">
            <li class="p-2">
                <router-link class="nav-link" to="/about"
                  >About</router-link
                >
              </li>

              <li class="p-2">
                <router-link class="nav-link" to="/#"
                  >Alumni</router-link
                >
              </li>
              <li class="p-2">
                <router-link class="nav-link" to="/dashboard"
                  >Student’s portal</router-link
                >
              </li>
          </ul>
          <ul class="navbar-nav pt-2" v-if="!$store.getters.loggedIn">
            <li class="p-2">
                <router-link class="nav-link btn btn-orange pl-3 pr-3" to="/#" style="border-radius: 15px; font-size:20px"
                  >Apply</router-link
                >
              </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "TalentNavbar",
  components: {
    // NavLinks: () => import('@/components/NavLinks')
  },
  methods: {},
};
</script>

<style scoped>
.navbar {
  border: 0;
  border-radius: 3px;
  /* padding: 0.625rem 0; */
  margin-bottom: 20px;
  color: #0599a9;
  background-color: #FEFBFB !important;
  box-shadow: 0 4px 18px 0px rgba(0, 0, 0, 0.12),
    0 7px 10px -5px rgba(0, 0, 0, 0.15);
  font-family: gotham;
  padding-left:6rem;
  padding-right:6rem;
}

.nav .nav-item {
  position: relative;
}

@media screen and (max-width: 567px) {
  .navbar {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

.navbar.navbar-transparent {
  /*border-bottom: 1px solid var(--grey);*/
  background: #FEFBFB !important;
  padding-top: 1.5rem;
  
}

.nav-item a {
  color: black !important;
  font-family: var(--gotham);
  font-size: 17px !important;
  text-transform: none !important;
}

.navbar {
  box-shadow: none;
}

.dropdown-menu .dropdown-item:focus,
.dropdown-menu a:hover {
  color: white !important;
}
</style>
